import React from "react";
import type { Project } from "../../../../api/useProjects";
import t from "../../../../i18n";
import useModal from "@ui/lib/hooks/useModal";
import Button from "@ui/Button";
import { useCanUserDoOnProject } from "../../../canUserDo";
import Modal from "@ui/Modal";
import LaunchAnalysisSelectionModalForm from "./LaunchAnalysisSelectionModalForm";

interface P {
  project: Project;
}

export const LaunchAnalysisSelectionAction = ({ project }: P) => {
  const { openModal, closeModal, modal: isModalOpen } = useModal();

  const canEdit = useCanUserDoOnProject("PROJECT_WRITE", project.id);
  if (
    !canEdit ||
    project.analysesAggregate?.activeAnalysisCount ||
    project.initInProgress !== false
  )
    return null;

  return (
    <>
      <Button variant="primary" slim type="button" onClick={openModal}>
        {t("project.button.navbar.actions.launch_selection_of_analyses")}
      </Button>
      <Modal
        title={t("project.modal.title.launch_selection_of_analyses")}
        subtitle={t("project.modal.subtitle.launch_selection_of_analyses")}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        size="xl"
      >
        <LaunchAnalysisSelectionModalForm
          modalType="LAUNCH_ANALYSIS_SELECTION"
          project={project}
          onRequestClose={closeModal}
        />
      </Modal>
    </>
  );
};
